import {trans} from '@frontend/helpers'
import {useFooterStore} from '@frontend/stores'
import clsx from 'clsx'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'
import {FooterContacts} from './FooterContacts'
import {FooterLogoAndLegalInfo} from './FooterLogoAndLegalInfo'
import {FooterNavigationForAppSections} from './FooterNavigationForAppSections'
import {FooterNavigationForServicePages} from './FooterNavigationForServicePages'

// Нижняя часть страницы со ссылками и копирайтом.
export function Footer() {

    const show = useFooterStore(
        state => state.visible
    )

    const showNavLinks = useFooterStore(
        state => state.navLinks
    )

    return (
        <Collapse
            tag="footer"
            show={show}
            showImmediately
        >
            <div className="container-fluid container-xl py-3">
                <div className="px-md-2 px-xl-0">
                    <Collapse
                        show={showNavLinks}
                        showImmediately
                    >
                        <div className="py-3 pt-xl-7">
                            <div className="border-bottom pb-2 pb-md-3 pb-xl-4 d-flex flex-column-reverse flex-md-row align-items-stretch justify-content-between">
                                <FooterNavigationForAppSections />
                                <FooterLogoAndLegalInfo />
                            </div>
                        </div>
                    </Collapse>
                    <div
                        className={clsx(
                            'py-2 pt-xl-3 pb-xl-5',
                            'd-flex flex-column-reverse align-items-stretch justify-content-between',
                            'flex-md-row align-items-lg-start'
                        )}
                    >
                        <FooterNavigationForServicePages />
                        <div
                            className={clsx(
                                'd-flex flex-column align-items-stretch justify-content-start',
                                'flex-lg-row align-items-lg-start'
                            )}
                        >
                            <FooterContacts />
                            <div className="fs-7 mt-2 mt-lg-0 ms-lg-7 text-center text-md-end">
                                <HtmlContent html={trans().common.footer.copyright} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Collapse>
    )
}
